const zh = {
  title: '消息中心',
  filterTpye: '消息类型',
  plzSelect: '请选择',
  serviceType: '业务公告',
  releaseTime: '发送时间',
  messageTitle: '消息标题',
  messageContent: '消息内容',
  sendTime: '发送时间',
  operation: '操作',
  viewDetails: '查看详情',
  allRead: '全部已读',
  messageDetails: '消息详情',
  confirm: '确定',
  close: '关闭',
}

export default zh
